import type { DialogContentNode } from "@/v2/framework/dialog/types";

import type { InheritanceFieldDescriptor, InheritableLeafField } from "../types";
import { resolveInheritanceDescriptor } from "./resolveBinding";

function isInheritableLeaf(
  node: DialogContentNode,
): node is DialogContentNode & InheritableLeafField {
  return (
    (node.type === "text-field" ||
      node.type === "select-field" ||
      node.type === "array-field" ||
      node.type === "structured-array-field") &&
    node.inheritance !== undefined
  );
}

export function collectInheritanceDescriptors(
  nodes: DialogContentNode[],
  prefix = "",
): InheritanceFieldDescriptor[] {
  const descriptors: InheritanceFieldDescriptor[] = [];

  for (const node of nodes) {
    if (node.type === "group") {
      const nextPrefix = prefix ? `${prefix}.${node.name}` : node.name;
      descriptors.push(...collectInheritanceDescriptors(node.children, nextPrefix));
      continue;
    }

    if (!isInheritableLeaf(node)) continue;

    const config = node.inheritance!;
    if (!config.computedKey || !config.parentKey) {
      throw new Error(
        `[tenant-inheritance] Field "${prefix ? `${prefix}.${node.name}` : node.name}" requires computedKey and parentKey`,
      );
    }

    const path = prefix ? `${prefix}.${node.name}` : node.name;
    descriptors.push(resolveInheritanceDescriptor(path, node.name, config));
  }

  return descriptors;
}

export function hasInheritanceFields(nodes: DialogContentNode[]): boolean {
  return collectInheritanceDescriptors(nodes).length > 0;
}
